module.exports = __webpack_public_path__ + "img/mind_skeleton_6.203cca41.png";